import { render } from "./Cockpit.vue?vue&type=template&id=2628098c&scoped=true"
import script from "./Cockpit.vue?vue&type=script&lang=js"
export * from "./Cockpit.vue?vue&type=script&lang=js"

import "./Cockpit.vue?vue&type=style&index=0&id=2628098c&scoped=true&lang=css"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2628098c"]])

export default __exports__